/**
 * Auth Service
 * Handles authentication API calls
 */

import api, { setAuthToken, removeAuthToken, setApiKey, removeApiKey, getAuthToken } from './api';
import { API_ENDPOINTS } from '../config/environment';

const authService = {
  /**
   * Login with email and password
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise<Object>} Auth response with token and user
   */
  login: async (email, password) => {
    const response = await api.post(API_ENDPOINTS.AUTH_LOGIN, { email, password });
    const { token, api_key, user } = response.data;
    
    // Store tokens
    if (token) setAuthToken(token);
    if (api_key) setApiKey(api_key);
    
    return response.data;
  },

  /**
   * Register new user
   * @param {Object} userData - User registration data
   * @returns {Promise<Object>} Registration response
   */
  register: async (userData) => {
    const response = await api.post(API_ENDPOINTS.AUTH_REGISTER, userData);
    const { token, api_key } = response.data;
    
    // Store tokens
    if (token) setAuthToken(token);
    if (api_key) setApiKey(api_key);
    
    return response.data;
  },

  /**
   * Get current user profile
   * @returns {Promise<Object>} User profile
   */
  getCurrentUser: async () => {
    const response = await api.get(API_ENDPOINTS.AUTH_ME);
    return response.data;
  },

  /**
   * Logout - clear stored tokens and notify server
   */
  logout: () => {
    // Fire-and-forget server logout - don't block on response
    return console.log('logout hit which code is commnetted')
    // api.post('/v1/auth/logout').catch(() => {});
    removeAuthToken();
    removeApiKey();
  },

  /**
   * Check if user is authenticated
   * @returns {boolean} Authentication status
   */
  isAuthenticated: () => {
    return !!getAuthToken();
  },
};

export default authService;

